import { useEffect } from 'react';

const getFieldLabel = (field) => {
  if (field.id) {
    const label = document.querySelector(`label[for="${field.id}"]`);
    if (label?.textContent) return label.textContent.replace('*', '').trim();
  }

  return field.getAttribute('aria-label') || field.name || 'This field';
};

const removeFieldError = (field) => {
  const errorId = field.dataset.inlineErrorId;
  if (errorId) document.getElementById(errorId)?.remove();
  field.classList.remove('has-inline-validation-error');
  field.removeAttribute('aria-invalid');
  field.removeAttribute('aria-describedby');
};

const showFieldError = (field) => {
  if (!field.form || field.type === 'hidden' || field.disabled) return;

  removeFieldError(field);
  const errorId = `inline-error-${field.name || field.id || Math.random().toString(36).slice(2)}`;
  const message = field.validationMessage || `${getFieldLabel(field)} is required.`;
  const error = document.createElement('div');

  error.id = errorId;
  error.className = 'field-validation-error';
  error.setAttribute('role', 'alert');
  error.textContent = message;
  field.insertAdjacentElement('afterend', error);
  field.dataset.inlineErrorId = errorId;
  field.classList.add('has-inline-validation-error');
  field.setAttribute('aria-invalid', 'true');
  field.setAttribute('aria-describedby', errorId);
};

const InlineFormValidation = () => {
  useEffect(() => {
    const handleInvalid = (event) => {
      event.preventDefault();
      showFieldError(event.target);
    };

    const handleFieldChange = (event) => {
      if (event.target.validity?.valid) removeFieldError(event.target);
    };

    document.addEventListener('invalid', handleInvalid, true);
    document.addEventListener('input', handleFieldChange, true);
    document.addEventListener('change', handleFieldChange, true);

    return () => {
      document.removeEventListener('invalid', handleInvalid, true);
      document.removeEventListener('input', handleFieldChange, true);
      document.removeEventListener('change', handleFieldChange, true);
    };
  }, []);

  return null;
};

export default InlineFormValidation;
